import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useGetJudgePhaseProjectsQuery } from '../../../hooks/scientific/useGetJudgePhaseProjectsQuery';
import { useGetPhasesQuery } from '../../../hooks/scientific/useGetPhasesQuery';
import { useGetJudgesQuery } from '../../../hooks/scientific/useGetJudgesQuery';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { ConfirmAlertDialog } from '../../../components/common/ConfirmAlertDialog';
import { Lists } from '../../../components/common/Lists';
import TableComponent from '../../../components/common/Tables';
import { JudgePhaseProjectType } from '../../../types/ScientificModule';
import { useMutation } from 'react-query';
import { createJudgePhaseProject, updateJudgePhaseProject } from '../../../services/scientific/judgePhaseProject';
import toast from 'react-hot-toast';
import { ChevronLeftIcon, Link2Icon, TrashIcon } from '@radix-ui/react-icons';
import SelectComponent from '../../../components/inputs/Select/SelectComponent';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../hooks/hooks';
import { routes } from '../../../routes';
import { resetProjectsData } from '../../../redux/slices/scientific/projects';
const columnNamesMap: { [key: string]: string } = {
  judge: "Interveniente",
  phase: "Fase/Etapa",
  project: "Projecto",
};
export const AssignJudgesToProjectPhases = () => {
  const projectFormData = useSelector((state: RootState) => state.projects);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const [deleteItem, setDeleteItem] = useState<JudgePhaseProjectType | null>(null);
  const { data: judgesPhasesProjects, status: statusJudgesPhasesProjects, refetch: refreshJudgesPhasesProjects } = useGetJudgePhaseProjectsQuery({ PageNumber: currentPage, PageSize: 400, IdProject: projectFormData.id },
    { enabled: !!projectFormData.id }
  );
  const judgePhaseProjects = judgesPhasesProjects?.items.filter(j=> j.idProject===projectFormData.id);
  const { data: phases } = useGetPhasesQuery({ PageNumber: 1, PageSize: 400, IdProjectType: projectFormData.idProjectType },
    { enabled: !!projectFormData.idProjectType }
  );
  const { data: judges } = useGetJudgesQuery({ PageNumber: 1, PageSize: 400 }
  );

  const openDeleteDialog = (s: JudgePhaseProjectType) => {
    setDeleteItem(s);
  };
  const confirmDelete = async () => {
    if (deleteItem) {
      await handleDelete(deleteItem!)
    }
  };
  const handleDelete = async (manager: any) => {
    manager.status = false;
    await mutationDelete.mutateAsync(manager)
    refreshJudgesPhasesProjects();
  };
  const mutation = useMutation(createJudgePhaseProject, {
    onSuccess: () => {
      toast.success("Vinculado!");
    },
    onError: () => {
      toast.error("Erro ao vincular.");
    }
  });

  const mutationDelete = useMutation(updateJudgePhaseProject, {
    onSuccess: () => {
      toast.success("Removido!");
    },
    onError: () => {
      toast.error("Erro ao remover associação.");
    }
  });

  const options = judgesPhasesProjects?.items.map(() => [
    {
      label: 'Eliminar',
      onClick: (manager: any) => openDeleteDialog(manager),
      icon: <TrashIcon />
    }

  ]) || [];
  const { control, handleSubmit, formState: { errors } } = useForm<JudgePhaseProjectType>({
    defaultValues: {
      idJudge: "",
      idPhase: "",
      idProject: projectFormData.id,
      comments: "N;D",
    }
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      data.comments = "N;D";
      await mutation.mutateAsync(data)
      refreshJudgesPhasesProjects();
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = () => {
    dispatch(resetProjectsData());
    navigate(routes.projects);
  };

  return (
    <Card size='3'>
      <Flex direction="row" gap='6'>
        <Flex direction="column" gap="5" style={{ flex: 1 }}>
          <form onSubmit={onSubmit} noValidate>
            <Flex direction="column" gap='4'>
              <SelectComponent
                label="Validador"
                options={judges?.items.map((j) => ({
                  value: j.id ?? "",
                  label: j.fullname ?? ""
                }))}
                errors={errors}
                control={control}
                name={"idJudge"}
                required={true}
              />
              <SelectComponent
                label="Fase/Etapa"
                options={phases?.items.map((p) => ({
                  value: p.id ?? "",
                  label: `${p.description}`
                }))}
                errors={errors}
                control={control}
                name={"idPhase"}
                required={true}
              />

              <Flex direction="row" gap="3" justify="end">
                <Button
                  type="button"
                  variant="soft"
                  color="gray"
                  onClick={handleBack}
                  disabled={mutation.isLoading}
                >
                  <ChevronLeftIcon /> Voltar
                </Button>
                <Button type="submit" disabled={mutation.isLoading}>
                  {mutation.isLoading ? <Spinner /> : <Link2Icon />}
                  Vincular
                </Button>
              </Flex>
            </Flex>
          </form>

        </Flex>

        <Flex direction="column" gap="4" style={{ flex: 1 }}>
          <Lists
            status={statusJudgesPhasesProjects}
            TableComponent={() => <TableComponent
              columns={Object.keys(columnNamesMap)}
              items={judgePhaseProjects}
              options={options}
              columnNamesMap={columnNamesMap}
              totalPages={judgesPhasesProjects?.totalPages || 1}
              currentPage={1}
              onPageChange={handlePageChange}
              emptyMessage="Ainda não existem intervenientes vinculados a este projecto." />}
            handleClickCreate={undefined} />
          <ConfirmAlertDialog
            open={!!deleteItem}
            onOpenChange={(open) => !open && setDeleteItem(null)}
            title="Esta operação é irreversível"
            description="A associação entre o interveniente e a fase será removida. Pretende continuar?"
            confirmLabel="Eliminar"
            item={deleteItem}
            onConfirm={confirmDelete}
            onCancel={() => setDeleteItem(null)}
          />
        </Flex>
      </Flex>
    </Card>

  );
}
